import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import withReducer from "app/store/withReducer";
import React from "react";
import IdleTimer from "react-idle-timer";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/ScreenLockActions";
import ScreenLockReducer from "./Store/Reducers/ScreenLockReducer";

const DEFAULT_TIMER = 5;

class ScreenLockApp extends XAPPComponent {

    constructor(props) {
        super(props);
        this.idleTimer = null;
        this.onAction = this._onAction.bind(this);
        this.onActive = this._onActive.bind(this);
        this.onIdle = this._onIdle.bind(this);
    }

    _onAction() {
        // console.log('user did something', e);
    }

    _onActive() {
        // console.log('user is active', e);
        // console.log('time remaining', this.idleTimer.getRemainingTime());
    }

    _onIdle() {
        // console.log('user is idle', e);
        // console.log('last active', this.idleTimer.getLastActiveTime());
        this.props.openDialog(true);
    }

    render() {
        const { children, disabled = false } = this.props;

        return (
            <React.Fragment>
                {!disabled &&
                    <IdleTimer
                        ref={ref => { this.idleTimer = ref; }}
                        element={document}
                        onActive={this.onActive}
                        onIdle={this.onIdle}
                        onAction={this.onAction}
                        debounce={250}
                        timeout={1000 * 60 * DEFAULT_TIMER}
                    />
                }
                {children}
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog: Actions.openDialog,
        disableScreenLock: Actions.disableScreenLock,
    }, dispatch);
}

function mapStateToProps({ ScreenLock }) {
    return {
        open: ScreenLock.open,
        disabled: ScreenLock.disabled,
    };
}

export default withReducer("ScreenLock", ScreenLockReducer)(withRouter(connect(mapStateToProps, mapDispatchToProps)(ScreenLockApp)));
